module.exports = __webpack_public_path__ + "static/img/1493_phase_function_Paper_Points.746b64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1493_phase_function_Paper_Points.png
// module id = p8l5
// module chunks = 0